import { FC } from 'react'
import { Phrase } from '@facesignai/api'
import { MessagesSquare } from 'lucide-react'

interface Props {
  transcript: Phrase[]
  language?: string
}

const TranscriptSection: FC<Props> = ({ transcript, language }) => {
  if (!transcript || transcript.length === 0) {
    return null
  }

  const formatTime = (timestamp: number) => {
    return new Date(timestamp).toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    })
  }

  return (
    <div className='bg-white rounded-lg shadow-sm p-6 mb-6'>
      <div className='flex items-center justify-between mb-4'>
        <div className='flex items-center gap-2'>
          <MessagesSquare className='text-blue-500' size={20} />
          <h2 className='text-lg font-semibold text-gray-900'>Transcript</h2>
        </div>
        <span className='text-sm text-gray-500'>{language || 'English'}</span>
      </div>
      <div className='bg-gray-900 rounded-lg p-4'>
        <p className='uppercase text-gray-400 text-xs mb-3'>CONVERSATION LOG</p>
        <div className='space-y-2'>
          {transcript
            .filter((entry) => entry.text && entry.text.trim() !== '')
            .map((entry, index) => (
              <div
                key={entry.id || index}
                className='text-sm font-mono flex items-start gap-3'
              >
                <span className='text-[10px] text-gray-500 mt-0.5 min-w-[48px]'>
                  {entry.createdAt ? formatTime(entry.createdAt) : ''}
                </span>
                <div>
                  <span
                    className={
                      entry.isAvatar ? 'text-blue-400' : 'text-green-400'
                    }
                  >
                    {entry.isAvatar ? 'FACESIGN' : 'USER'}:
                  </span>
                  <span className='text-gray-300 ml-2'>{entry.text}</span>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export default TranscriptSection
